"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@lingui/core");
var _react = require("@lingui/react");
var _react2 = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var AuthorAttribution = function AuthorAttribution(_ref) {
  var text = _ref.text;
  var authorAttributionText = /*i18n*/_core.i18n._("By Autodesk Support");
  return /*#__PURE__*/_react2.default.createElement(_react.I18nProvider, {
    i18n: _core.i18n
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-mb-1"
  }, /*#__PURE__*/_react2.default.createElement("p", {
    className: "MuiTypography-root MuiTypography-headline-smaller dhig-typography dhig-typography-headline-smaller"
  }, text === '' || !text ? authorAttributionText : text)));
};
var _default = AuthorAttribution;
exports.default = _default;
AuthorAttribution.propTypes = {
  text: _propTypes.default.string
};
AuthorAttribution.defaultProps = {
  text: ''
};